import { render, staticRenderFns } from "./Additionals.vue?vue&type=template&id=5939d47a&scoped=true&"
import script from "./Additionals.vue?vue&type=script&lang=js&"
export * from "./Additionals.vue?vue&type=script&lang=js&"
import style0 from "./Additionals.vue?vue&type=style&index=0&id=5939d47a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5939d47a",
  null
  
)

export default component.exports